export function getAgreementLeadRessourceId(agreementLead) {
    return agreementLead?.ressource?.id ?? agreementLead?.id ?? null;
}

export function buildAgreementLeadsPayload(data, pilotsValues) {
    return pilotsValues.map((_pilot, index) => {
        return {
            budget: data[`agreement_budget_${index}`],
            daily_rate: data[`agreement_daily_rate_${index}`],
            ressource_id: getAgreementLeadRessourceId(data[`agreement_lead_${index}`])
        };
    });
}

export function hasMissingAgreementLeadRessource(agreementLeads) {
    return agreementLeads.some((agreementLead) => agreementLead.ressource_id == null);
}
